import mpDiscountsApi from "@/api/mpDiscounts";

const state = {
    all: [],
    mpDiscount: {},
    missingDiscounts: [],
    activeDiscounts: []
};

const getters = {
    mpDiscount: state => {
        return state.mpDiscount;
    },
    missingDiscounts: state => {
        return state.missingDiscounts;
    },
    activeDiscounts: state => {
        return state.activeDiscounts;
    },
    mpDiscountCategories: state => {
        return state.all.filter(n => n.state).map(m => {
            return {
                name: `%${m.discountRate} - ${m.isAllProduct ? 'Tüm Ürünler' : 'Seçili Ürünler'}`,
                id: m.id
            };
        });
    }
};

const actions = {
    getAllMpDiscounts: async context => {
        let d = (await mpDiscountsApi.getMpDiscounts()).data;
        context.commit("getMpDiscounts", d);
    },
    searchMpDiscount: async (context, mpDiscount) => {
        let d = (await mpDiscountsApi.searchMpDiscount(mpDiscount)).data;
        context.commit("getMpDiscounts", d);
        return d;
    },
    getMpDiscount: async (context, id) => {
        let d = (await mpDiscountsApi.getMpDiscount(id)).data;
        context.commit("getMpDiscount", d);
        return d;
    },
    postMpDiscount: async (context, mpDiscount) => {
        const result = (await mpDiscountsApi.postMpDiscount(mpDiscount)).data;
        context.commit("postMpDiscount", result);
        return result;
    },
    putMpDiscount: async (context, mpDiscount) => {
        const result = (await mpDiscountsApi.putMpDiscount(mpDiscount)).data;
        context.commit("putMpDiscount", result);
        return result;
    },
    deleteMpDiscount: async (context, mpDiscount) => {
        await mpDiscountsApi.deleteMpDiscount(mpDiscount);
        context.commit("deleteMpDiscount", mpDiscount);
    },
    
    // Özel actions
    getMissingDiscounts: async context => {
        let d = (await mpDiscountsApi.getMissingDiscounts()).data;
        context.commit("getMissingDiscounts", d);
        return d;
    },
    syncFromMainDiscounts: async (context, discountIds = null) => {
        await mpDiscountsApi.syncFromMainDiscounts(discountIds);
        // Sync işleminden sonra listeyi yenile
        await context.dispatch('getAllMpDiscounts');
        return true;
    },
    getMpDiscountsByMarketplace: async context => {
        let d = (await mpDiscountsApi.getMpDiscountsByMarketplace()).data;
        context.commit("getMpDiscounts", d);
        return d;
    },
    getActiveDiscounts: async context => {
        let d = (await mpDiscountsApi.getActiveDiscounts()).data;
        context.commit("getActiveDiscounts", d);
        return d;
    }
};

const mutations = {
    getMpDiscounts(state, mpDiscounts) {
        state.all = mpDiscounts;
    },
    getMpDiscount(state, mpDiscount) {
        state.mpDiscount = null;
        state.mpDiscount = Object.assign({}, state.mpDiscount, mpDiscount);
    },
    postMpDiscount(state, mpDiscount) {
        state.all.push(mpDiscount);
        state.mpDiscount = null;
        state.mpDiscount = Object.assign({}, state.mpDiscount, mpDiscount);
    },
    putMpDiscount(state, mpDiscount) {
        const index = state.all.findIndex(item => item.id === mpDiscount.id);
        if (index !== -1) {
            state.all.splice(index, 1, mpDiscount);
        }
        state.mpDiscount = null;
        state.mpDiscount = Object.assign({}, state.mpDiscount, mpDiscount);
    },
    deleteMpDiscount(state, mpDiscount) {
        state.all.splice(state.all.indexOf(mpDiscount), 1);
    },
    getMissingDiscounts(state, discounts) {
        state.missingDiscounts = discounts;
    },
    getActiveDiscounts(state, discounts) {
        state.activeDiscounts = discounts;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
